import { NavigateFunction, useNavigate } from "react-router-dom";
import { SelectItemsProps } from "./components/ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import { useSchedule } from "./context/ScheduleContext";
import Routes from "./helpers/Routes";
import { ClientDTO } from "./models/Client/ClientDTO";
import { EquipmentDTO } from "./models/Equipment/EquipmentDTO";
import { CreateScheduleDTO } from "./models/Scheduler/CreateScheduleDTO";


class ScheduleUtilitiesClass {

    protected navigate?;

    constructor(navigate?: NavigateFunction) {
        this.navigate = navigate;
    }

    public GetScheduleTypes(intl: any): SelectItemsProps[] {
        return [
            { value: "CheckIn", label: intl.formatMessage({ id: "SchedulerUtitilies.GetScheduleTypes.CheckIn" }) },
            { value: "Execution", label: intl.formatMessage({ id: "SchedulerUtitilies.GetScheduleTypes.Execution" }) },
        ];
    }

}
export const ScheduleUtilities = new ScheduleUtilitiesClass();

export const ScheduleUtilitiesWithNavigate = (navigate: NavigateFunction) => {
    return new ScheduleUtilitiesClass(navigate);
}

export const useNavigateToScheduleCreate = () => {
    const { setScheduleDTO, setIsCreateFormVisible } = useSchedule();
    const navigate = useNavigate();

    return async (
        assistanceId: number | null,
        assistanceDocType: string | null,
        assistanceDocSerie: string | null,
        assistanceDocNumber: string | null,
        assistanceClient: ClientDTO | null,
        assistanceEquipment: EquipmentDTO | null
    ) => {
        const scheduleDTO: CreateScheduleDTO = {
            assistanceId: assistanceId,
            assistanceName: `${assistanceDocType} ${assistanceDocSerie} ${assistanceDocNumber}`,
            clientErpId: assistanceClient?.erpId ?? null,
            clientName: assistanceClient?.name ?? null,
            equipmentErpId: assistanceEquipment?.erpId ?? null,
            equipmentCarPlateName: assistanceEquipment?.carPlate ?? null,
            equipmentSerialNumberName: assistanceEquipment?.serialNumber ?? null,
            equipmentBrandName: assistanceEquipment?.brand ?? null,
            equipmentModelName: assistanceEquipment?.model ?? null,
            equipmentSkuName: assistanceEquipment?.sku ?? null,
            checkinStartDate: null,
            checkinEndDate: null,
            checkinNotes: null,
            checkinTechnicianId: null,
            executionStartDate: null,
            executionEndDate: null,
            executionNotes: null,
            executionTechnicianId: null,
            type: null
        };

        setScheduleDTO(scheduleDTO);
        setIsCreateFormVisible(true);
        navigate(Routes.scheduler.list);
    };
};